export default __webpack_public_path__ + "static/media/filter_flag_blue.9e8bd1b9.svg";